export const PAGE_LOADER_TEXT = "Please wait while we set things up for you...";
export const PROCESSING_TRASACTION_TEXT = "Processing transaction...";
export const TRANSACTION_FAILURE_TEXT =
  "Transaction failed, please try again :(";
export const REJECTED_TEXT = "User rejected the request.";
export const CONNECTING_WALLET_TEXT = "Connecting Wallet...";
export const WALLET_CONNECTION_SUCCESS_TEXT = "Wallet connected successfully!";
export const WALLET_CONNECTION_FAILUE_TEXT =
  "Connection failed, please try again :(";
export const BANNER_TEXT = `We are in alpha mode right now`;
export const NO_WALLET_DETECTED_TEXT =
  "Earn the highest staking rewards possible by staking MATIC, with the power of our auto-compounding feature.";

export const AVAIALABLE_TO_BE_CLAIMED = "Available to be Claimed";

export const TERMS_URL = "https://staderlabs.com/terms-of-service";
export const ADVISORY =
  "This is a beta launch, deposited BNB may be at risk, please deposit responsibly. Request you to deposit from the BNB provided by us in your wallet.";
export const TVL_REACHED_MESSAGE =
  "TVL for Capped Launch has been reached. We'll be lifting caps on 18th April. Please check back in again.";

export const TVL_TOOLTIP_TEXT = "Total BNB staked with Stader";
export const APY_TOOLTIP_TEXT = "Estimated Annualized Return";
export const EXCHANGE_RATE_TOOLTIP_TEXT =
  "Actual exchange rate may vary from the displayed value";
export const AUDIT_TOOLTIP_TEXT = "Click to know more on audits";
export const UNSTAKE_TOOLTIP_TEXT =
  "Actual amount might change based on the exchange rate at the time we send unstaking request to the network. To know more refer to our FAQs";

export const NETWORK_KEY = "current-network-id";

export const STADER_URL = "https://staderlabs.com/";
export const TWITTER_URL = "https://twitter.com/stader_bnb";
export const FAQ_URL = "https://docs-new.staderlabs.com/category/bnb-chain";
export const WALLET_FAQ_URL =
  "https://docs-new.staderlabs.com/category/bnb-chain/wallets";
export const TELEGRAM_URL = "https://t.me/staderlabs_bnb_official";
export const SUBSCRIBE_URL =
  "https://docs.google.com/forms/d/1dWAmpKI-w9TsMWcVQBRz4OvyF3vaS6UdO-rvuLejb2M/viewform";
export const LEARN_MORE_URL =
  "https://staderlabs.notion.site/Stader-BNB-8fd6a8df6f22413fac7babf75ed56f88";
export const REDDIT_URL = "https://www.reddit.com/r/StaderBNBofficial/";

export const VAULTS_LET_US_KNOW = "https://forms.gle/cfmazoYt9FEKEVrYA";

export const VAULT_WOMBAT_FEE =
  "https://docs.wombat.exchange/docs/concepts/fees/deposit-gain-and-withdrawal-fee";
